import i from "styled-components";
import o from "../../../utils/colors.js";
import { device as e } from "../../../utils/device.js";
import n from "../../Icons/Alert.js";
import a from "../../Icons/Spinner.js";
import p from "../../Icons/Tick.js";
const t = i.div``, f = i.aside`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`, b = i(t)`
  padding: 8px;
  display: flex;
  font-size: 16px;
  font-family: 'VIC';

  @media ${e.isDesktop}, ${e.isTablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media ${e.isMobile} {
    flex-wrap: wrap;
    border: ${(r) => r.error ? `1px solid ${o.red}` : "none"};
  }
`, g = i(t)`
  padding: 16px 0px 15px;
  box-sizing: border-box;
  border-bottom: 1px solid ${o.darkGrey10};
`, h = i(t)`
  width: 50px;
  height: 50px;
`, $ = i(t)`
  color: ${o.blueGrey};
  display: flex;
  width: 100%;
  flex-direction: column;
  letter-spacing: -0.32px;
  word-break: break-word;

  @media ${e.isMobile} {
    flex-grow: 1;
    width: 60vw;
    flex-direction: ${(r) => r.error ? "column-reverse" : "column"};
  }
`, w = i(t)`
  display: flex;
  flex-grow: 1;

  @media ${e.isDesktop}, ${e.isTablet} {
    flex-direction: row;
  }
`, y = i(t)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`, u = i.a.attrs((r) => ({
  target: r.target ?? "_self"
}))`
  color: ${o.brown};
  text-decoration: none; // normally not needed to be explicit, but SiteCore has a different base style

  > button {
    width: 110px;

    @media ${e.isDesktop}, ${e.isTablet} {
      height: auto;
    }

    @media ${e.isMobile} {
      padding-left: 0;
    }
  }
`, k = i(t)`
  color: ${o.blueGrey};
  padding-top: 6px;
  letter-spacing: -0.32px;

  @media ${e.isMobile} {
    display: none;
  }
`, M = i(a)`
  width: 40px;
  height: 40px;
  margin: 6px 18px 0 0;

  @media ${e.isMobile} {
    margin: 0;
  }
`, T = i(p)`
  width: 32px;
  height: 25px;
  margin: 0;

  @media ${e.isMobile} {
    flex-shrink: 1;
  }

  @media ${e.isDesktop}, ${e.isTablet} {
    margin-right: 23px;
  }
`, D = i(n)`
  width: 32px;
  height: 27px;
  margin: 0;

  path {
    fill: ${o.red};
  }

  @media ${e.isMobile} {
    flex-shrink: 1;
  }

  @media ${e.isDesktop}, ${e.isTablet} {
    margin-right: 25px;
  }
`, W = i(t)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  height: 100%;

  @media ${e.isMobile} {
    width: 100%;
  }
`, C = i(t)`
  display: flex;
  flex-direction: row;
`;
export {
  t as BaseWrapper,
  C as ButtonsContainer,
  f as Container,
  y as Content,
  D as Error,
  k as FileSizeWrapper,
  W as ImageWrapper,
  $ as Info,
  g as ItemWrapper,
  u as Link,
  M as Spinner,
  h as Thumbnail,
  T as Tick,
  w as UploadDataWrapper,
  b as Wrapper
};
